const ITEMS = [
    "WHOLESALE SPECIALISTS",
    "Latest Trends",
    "BEST QUALITY",
    "Family Fashion",
    "MEN’S WEAR",
    "Women’s Wear",
    "KIDS COLLECTION",
    "Fabric Rolls",
];

const Diamond = () => (
    <span className="mx-7 inline-block h-2 w-2 shrink-0 rotate-45 bg-current opacity-70" aria-hidden="true" />
);

export default function Marquee() {
    return (
        <div
            data-testid="brand-marquee"
            className="overflow-hidden border-y border-maroon-950/20 bg-gold py-4 text-maroon-950"
            aria-hidden="true"
        >
            <div className="flex w-max animate-marquee">
                {[0, 1].map((copy) => (
                    <div key={copy} className="flex shrink-0 items-center">
                        {ITEMS.map((item, i) => (
                            <span key={item} className="flex items-center whitespace-nowrap">
                                {i % 2 === 0 ? (
                                    <span className="text-sm font-bold uppercase tracking-[0.3em]">{item}</span>
                                ) : (
                                    <span className="font-display text-[1.35rem] italic leading-none">{item}</span>
                                )}
                                <Diamond />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}